import MenuItem from "./../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'
import SalesTaxConfiguration from "./SalesTaxConfiguration";

let routes = [{
  path: 'sales-tax-configuration',
  name: 'sales-tax-configuration',
  component: SalesTaxConfiguration,
  meta: {
    requiresAuth: true
  }
}];

export default {
  menuItem: new MenuItem('/sales-tax-configuration', i18n.t('Sales Tax Config'), 40, 'percentage'),
  routes: routes
}
